import {
  Edge as ReactFlowEdge,
  Connection as ReactFlowConnection,
} from '@xyflow/react';

export enum ConnectionType {
  PORT_TO_PORT = 'port_to_port',
  PORT_TO_PARAM = 'port_to_param',
  CONDITIONAL = 'conditional',
  /** Visual semantic back-edge compiled into a bounded acyclic runtime plan. */
  REPEAT = 'repeat',
}

export interface CustomEdgeData extends Record<string, unknown> {
  /** Stable Switch case/default label consumed by branch gating. */
  branch_label?: string;
  /** Run-time presentation hint; persistence does not depend on it. */
  branch_selected?: boolean;
}

export type CustomEdge = ReactFlowEdge & {
  id: string;

  // React Flow Edge Type IDs
  source: string; // react_flow_generated_id of the source node
  sourceHandle: string; // port_id of the source output port
  target: string; // react_flow_generated_id of the target node
  targetHandle: string; // port_id of the target input port

  // node_id in node.data.struct so it's basically node name in snake case i.e "data_analysis_agent_node"
  sourceNodeId?: string;
  targetNodeId?: string;

  // fields BE expects (LEGACY)
  source_node_id?: string;
  source_port_id?: string | null;
  target_node_id?: string;
  target_port_id?: string | null; // port_id of the target port if connection is Port to Port

  // fields BE expects
  target_param_id?: string | null; // field_id of the parameter if connection is Port to Param even though it has a params[x].bindable_config.input_port.id
  edge_type: ConnectionType;

  data?: CustomEdgeData;
};

export interface CustomConnection extends ReactFlowConnection {
  target_param_id?: string | null;
  edge_type?: ConnectionType;
  source_port_id?: string | null;
  target_port_id?: string | null;
  data?: CustomEdgeData;
}
